import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { sendPasswordReset } from "./firestoreService"; // Make sure this function exists in your service file
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Alert,
} from "@mui/material";

function Profile() {
  // Get user data from our authentication context
  const { currentUser, userRole, organizationName } = useAuth();
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const { t } = useTranslation();

  const handlePasswordReset = async () => {
    setError("");
    setMessage("");
    try {
      await sendPasswordReset(currentUser.email);
      setMessage(t("profile.resetLinkSent", { email: currentUser.email }));
    } catch (err) {
      setError(t("profile.resetLinkFailed"));
      console.error(err);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        {t("profile.myProfile")}
      </Typography>
      <Paper elevation={3}>
        <List>
          {/* Display Name */}
          <ListItem>
            <ListItemText
              primary={t("profile.fullName")}
              secondary={currentUser?.displayName || "N/A"}
            />
          </ListItem>
          <Divider />

          {/* Email */}
          <ListItem>
            <ListItemText
              primary={t("auth.emailAddress")}
              secondary={currentUser?.email || "N/A"}
            />
          </ListItem>
          <Divider />

          {/* Role */}
          <ListItem>
            <ListItemText
              primary={t("common.role")}
              secondary={userRole ? userRole.replace("_", " ") : "N/A"}
              sx={{ textTransform: "capitalize" }}
            />
          </ListItem>
          <Divider />

          {/* Organization */}
          <ListItem>
            <ListItemText
              primary={t("common.organization")}
              secondary={organizationName || "N/A"}
            />
          </ListItem>
        </List>
      </Paper>

      {/* Action Box */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          {t("profile.accountActions")}
        </Typography>
        <Paper elevation={3} sx={{ p: 3 }}>
          {message && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {message}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography variant="body1" sx={{ mb: 2 }}>
            {t("profile.passwordResetInfo")}
          </Typography>
          <Button variant="contained" onClick={handlePasswordReset}>
            {t("profile.sendPasswordReset")}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}

export default Profile;
